import { render, staticRenderFns } from "./video-list.vue?vue&type=template&id=058b673d&scoped=true"
import script from "./video-list.vue?vue&type=script&lang=js"
export * from "./video-list.vue?vue&type=script&lang=js"
import style0 from "./video-list.vue?vue&type=style&index=0&id=058b673d&prod&lang=scss&scoped=true"
import style1 from "./video-list.vue?vue&type=style&index=1&id=058b673d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058b673d",
  null
  
)

export default component.exports